module.exports = __webpack_public_path__ + "static/lunchtype23-regular-italic-webfont-91d9f4a11dcf3fa6f7204b26744e8e66.eot";